import { FirebaseAuth } from '../../../../lib/firebase'

export const signOut = (): Promise<void> => FirebaseAuth.signOut()
